import * as React from 'react';
import { FC } from 'react';
import {
  Create,
  CreateProps,
  FormTab,
  NumberInput,
  required,
  SelectInput,
  TabbedForm,
  TextInput,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { LinkTypeOptions } from '../utils';
import { CustomToolbar } from '../components/toolbars';

export const styles = {
  price: { width: '7em' },
  width: { width: '7em' },
  height: { width: '7em' },
  stock: { width: '7em' },
  widthFormGroup: { display: 'inline-block' },
  heightFormGroup: { display: 'inline-block', marginLeft: 32 },
};
const useStyles = makeStyles(styles);

const LinkCreate: FC<CreateProps> = props => {
  const classes = useStyles();
  return (
    <Create {...props}>
      <TabbedForm
        redirect="show"
        toolbar={<CustomToolbar saveable alwaysEnableSaveButton={true} />}
      >
        <FormTab label="resources.apps.tabs.details">
          <NumberInput source="id" />
          <TextInput source="source" fullWidth />
          <TextInput source="destination" fullWidth />
          <SelectInput source="type" choices={LinkTypeOptions} />
        </FormTab>
      </TabbedForm>
    </Create>
  );
};
const requiredValidate = [required()];

export default LinkCreate;
